import { getEnv } from '@/env/env';

if (window.__al_cfg?.id || window.__al_cfg?.preview) {
    let id = window.__al_cfg?.id;

    if (window.__al_cfg?.preview) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (params.id) {
            id = params.id;
        }
    }
    const v = Math.random() * 10;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', getEnv().liveBaseUrl + '/' + id + '?version=' + v);
    iframe.setAttribute('title', 'Apenday Live');
    iframe.setAttribute('id', 'apenday-live-iframe');
    iframe.setAttribute('allow', 'camera;microphone');
    iframe.style.width = '0';
    iframe.style.height = '0';

    iframe.style.display = 'block';
    iframe.style.border = 'none';
    iframe.style.position = 'fixed';
    iframe.style.inset = 'auto 0px 0px auto';
    iframe.style.maxHeight = '100vh';
    iframe.style.opacity = '1';
    iframe.style.colorScheme = 'none';
    iframe.style.background = 'none transparent !important';
    iframe.style.margin = '0px';
    iframe.style.maxWidth = '100vw';
    iframe.style.transform = 'translateY(0px)';
    iframe.style.transition = 'none 0s ease 0s !important';
    iframe.style.visibility = 'visible';
    iframe.style.zIndex = '999';
    document.body.appendChild(iframe);

    /**  Popin Script  **/
    const urlObject = new URL(getEnv().baseUrl);
    //@ts-ignore:next-line
    window.scheduling = { server: urlObject.host };

    const scriptScheduling = document.createElement('script');
    scriptScheduling.setAttribute('src', getEnv().baseUrl + '/assets/js/scheduling.js');
    scriptScheduling.setAttribute('defer', '');
    document.head.appendChild(scriptScheduling);
    /** End Popin Script **/

    window.addEventListener('message', function ({ data }) {
        if (typeof data === 'string') {
            // small security to process only apenday message
            const message = JSON.parse(data);
            if (message.width && message.height) {
                iframe.style.width = message.width;
                iframe.style.height = message.height;
            }
            //@ts-ignore:next-line
            if (message.url && window.openCdScheduling) {
                //@ts-ignore:next-line
                window.openCdScheduling(message.url);
            }
        }
    });
}
